export const optionsRecentlyViewed = {
  mdSlidesPerView: 3.12, // fractions set to compensate swiper.js weird behavior if sledes offsets set
  lgSlidesPerView: 4.15,
  xlSlidesPerView: 4.27,
};

export const optionsRelated = {
  mdSlidesPerView: 3.12, // fractions set to compensate swiper.js weird behavior if sledes offsets set
  lgSlidesPerView: 4.15,
  xlSlidesPerView: 4.27,
};

export const optionsRelatedProducts = {
  smSlidesPerView: 1.6,
  mdSlidesPerView: 2.5,
  lgSlidesPerView: 3.7,
  xlSlidesPerView: 5.5,
};

export const optionsSpaceBetween = {
  smSpaceBetween: 12,
  mdSpaceBetween: 12,
  lgSpaceBetween: 25,
  xlSpaceBetween: 54,
};

export const titleOptions = {
  related: {
    title: 'Customers also loved',
  },
  recently: {
    title: 'Still thinking about these?',
  },
};
